module.exports = __webpack_public_path__ + "media/images/map/pin-5b563ae8510f9ba6e881e9d6aca0936d.svg";